<div class="grid-extraction-panel" #gridPanel>
  <div class="panel-header">
    <h3>
      <mat-icon>grid_on</mat-icon>
      Grid Extraction Results
    </h3>
    <br />
    <div class="header-stats">
      <span class="stat">{{ gridData?.rows || 0 }} rows</span>
      <span class="stat">{{ gridData?.cols || 0 }} columns</span>
      <span class="stat active">{{ getActiveRowsCount() }} active rows</span>
      <span class="stat ignored">{{ getIgnoredRowsCount() }} ignored rows</span>
    </div>
  </div>

  <div class="panel-content" *ngIf="gridData">
    <div class="table-wrapper">
      <p-table [value]="displayRows" styleClass="grid-extraction-table" [scrollable]="false">
          <ng-template pTemplate="header">
            <tr>
              <th
                *ngFor="let col of displayColumns"
                [attr.data-field]="columnMappings[col.colIndex] || 'unmapped'"
                [style.width.px]="col.widthPx || null"
              >
                <div class="column-header">
                  <div class="column-title">{{ col.header }}</div>
                  <p-dropdown
                    [options]="lineItemColumnOptions"
                    [(ngModel)]="columnMappings[col.colIndex]"
                    optionLabel="header"
                    optionValue="field"
                    placeholder="Map..."
                    [styleClass]="getDropdownStyleClass(col.colIndex)"
                  ></p-dropdown>
                </div>
              </th>
              <th class="ignore-header"></th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-rowData>
            <tr [class.ignored-row]="rowData.ignored">
              <td
                *ngFor="let col of displayColumns"
                [attr.data-field]="columnMappings[col.colIndex] || 'unmapped'"
                [style.width.px]="col.widthPx || null"
                [ngClass]="{
                  'ignored-cell': rowData[col.field]?.ignored,
                  'low-confidence-cell': rowData[col.field]?.hasLowConfidence && !rowData[col.field]?.ignored
                }"
              >
                <!-- Plain input with Prime classes; avoid pInputText to prevent recursive change-detection storms when many cells render -->
                <input
                  type="text"
                  [(ngModel)]="rowData[col.field].text"
                  (focus)="onCellFocus(rowData[col.field])"
                  (ngModelChange)="onCellEdit(rowData[col.field], $event)"
                  (keydown)="onCellKeydown($event, rowData.rowIndex, col.colIndex)"
                  [disabled]="rowData.ignored"
                  class="cell-input p-inputtext p-component"
                  [attr.data-row]="rowData.rowIndex"
                  [attr.data-col]="col.colIndex"
                />
              </td>
              <td class="row-actions">
                <button
                  mat-icon-button
                  (click)="toggleRowIgnore(rowData.rowIndex)"
                  [matTooltip]="rowData.ignored ? 'Include row' : 'Ignore row'"
                  [class.ignored]="rowData.ignored"
                  style="width: 24px; height: 24px; line-height: 24px"
                >
                  <mat-icon style="font-size: 14px">{{
                    rowData.ignored ? 'visibility' : 'visibility_off'
                  }}</mat-icon>
                </button>
              </td>
            </tr>
          </ng-template>
      </p-table>
    </div>
  </div>

  <div class="panel-footer">
    <div class="footer-actions">
      <div class="left-actions">
        <p-button
          icon="pi pi-times"
          label="Close"
          severity="danger"
          [outlined]="true"
          size="small"
          (click)="onClose()"
          styleClass="action-btn"
          [pTooltip]="'Close Panel'"
          tabindex="-1"
        ></p-button>
        <p-button
          icon="pi pi-refresh"
          label="Overwrite All"
          severity="success"
          [outlined]="true"
          size="small"
          (click)="onImportOverwrite()"
          [disabled]="getActiveRowsCount() === 0 || !hasSufficientMappings()"
          styleClass="action-btn"
          [pTooltip]="'Replace all existing data with new data'"
          tabindex="-1"
        ></p-button>
      </div>
      <div class="right-actions">
        <p-button
          icon="pi pi-plus-circle"
          label="Add to Existing"
          severity="success"
          size="small"
          (click)="onImportAdd()"
          [disabled]="getActiveRowsCount() === 0 || !hasSufficientMappings()"
          styleClass="action-btn"
          [pTooltip]="'Add selected data to existing records'"
          tabindex="-1"
        ></p-button>
      </div>
    </div>
    <span *ngIf="!hasSufficientMappings() && !isStatementMappingMode()" class="mapping-warning">
      Map Qty plus at least one of PLU/Supplier Reference/Description and one of Net or Gross Total.
    </span>
    <span *ngIf="!hasSufficientMappings() && isStatementMappingMode()" class="mapping-warning">
      Map at least one statement column.
    </span>
  </div>
</div>
